/**
 * Modal de confirmación para eliminar una lista.
 *
 * Móvil: bottom sheet (desliza desde abajo)
 * Escritorio: dialog centrado estándar
 */
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, Box, Slide, useTheme, useMediaQuery,
} from "@mui/material";

/** Transición desde abajo para el bottom sheet */
const SlideUp = (props) => <Slide direction="up" {...props} />;

export default function ConfirmarEliminarModal({ open, onClose, lista, onConfirm }) {
    const theme    = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (!lista) return null;

    /* ── MÓVIL: Bottom sheet ─────────────────────────────────────── */
    if (isMobile) {
        return (
            <Dialog
                open={open}
                onClose={onClose}
                TransitionComponent={SlideUp}
                fullWidth
                PaperProps={{
                    sx: {
                        position:     "fixed",
                        bottom:       0,
                        left:         0,
                        right:        0,
                        m:            0,
                        width:        "100%",
                        maxWidth:     "100%",
                        borderRadius: "20px 20px 0 0",
                        pb:           "env(safe-area-inset-bottom)",
                    },
                }}
                sx={{ "& .MuiDialog-container": { alignItems: "flex-end" } }}
            >
                {/* Pastilla visual de arrastre */}
                <Box sx={{ display: "flex", justifyContent: "center", pt: 1.5 }}>
                    <Box sx={{ width: 40, height: 4, borderRadius: 99, bgcolor: "divider" }} />
                </Box>

                <Box sx={{ px: 2.5, pt: 1.5, pb: 3 }}>
                    <Typography variant="h6" color="error" sx={{ fontWeight: 800, mb: 1 }}>
                        Eliminar lista
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        ¿Seguro que quieres eliminar la lista <strong>{lista.nombre}</strong>?
                        Esta acción no se puede deshacer.
                    </Typography>

                    {/* Botones full width en móvil */}
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                        <Button
                            fullWidth variant="outlined"
                            onClick={onClose}
                            sx={{ borderRadius: 2, minHeight: 48, fontWeight: 700, textTransform: "none" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            fullWidth variant="contained" color="error"
                            onClick={onConfirm}
                            sx={{ borderRadius: 2, minHeight: 48, fontWeight: 700, textTransform: "none" }}
                        >
                            Eliminar
                        </Button>
                    </Box>
                </Box>
            </Dialog>
        );
    }

    /* ── ESCRITORIO: Dialog centrado ─────────────────────────────── */
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 800 }}>Eliminar lista</DialogTitle>
            <DialogContent>
                <Typography>
                    ¿Seguro que quieres eliminar la lista <strong>{lista.nombre}</strong>?
                    <br />Esta acción no se puede deshacer.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ textTransform: "none" }}>Cancelar</Button>
                <Button variant="contained" color="error" onClick={onConfirm} sx={{ textTransform: "none", fontWeight: 700 }}>
                    Eliminar
                </Button>
            </DialogActions>
        </Dialog>
    );
}